// ./src/components/features/CreateEventWizard/WizardContext.tsx
//
// Context that hands the shared draft + navigation controls down to each step, so
// a step component stays a thin, presentational panel. The shell computes the
// value; steps consume it via useEventWizard().

import { createContext, useContext } from 'react';

import { EventWizardContextValue } from './wizardTypes';

const WizardContext = createContext<EventWizardContextValue | null>(null);

export const WizardProvider = WizardContext.Provider;

export const useEventWizard = (): EventWizardContextValue => {
  const value = useContext(WizardContext);
  if (!value) {
    throw new Error('useEventWizard must be used within the Create Event wizard shell');
  }
  return value;
};
